import React, { Component, forwardRef } from "react"
import * as dateHelper from "../../booking/helpers/date"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import DatePicker, { CalendarContainer } from "react-datepicker"
import da from "date-fns/locale/da"
import enGB from "date-fns/locale/en-GB"
import { isMobile } from "react-device-detect"
import { DateTime } from "luxon"

export default class ParkingSearch extends Component {
  constructor(props) {
    super(props)

    const arrivalLeadTimeHours = props.leadTimeInHours || 1
    const arrivalGranularityMilliseconds = 30 * 60 * 1000

    const dtLocale = dateHelper.luxonLocale(props.locale)
    const zone = "Europe/Copenhagen"
    const currentTime = DateTime.local().setLocale(dtLocale).setZone(zone)
    const cphTime = currentTime.setZone("local", { keepLocalTime: true })

    const earliestArrivalTimeStamp = DateTime.fromMillis(cphTime.toMillis() + arrivalLeadTimeHours * 60 * 60 * 1000)
    const arrivalDate = DateTime.fromMillis(Math.ceil(earliestArrivalTimeStamp / arrivalGranularityMilliseconds) * arrivalGranularityMilliseconds)
    const departureDate = cphTime.plus({ days: 7 }).set({ hours: 17, minutes: 30, seconds: 0, milliseconds: 0 })

    const today = cphTime
    const maxTime = cphTime.set({ hours: 23, minutes: 30, seconds: 0, milliseconds: 0 })
    const minTime = cphTime.set({ hours: 0, minutes: 30, seconds: 0, milliseconds: 0 })

    this.adtCalender = React.createRef()
    this.ddtCalender = React.createRef()

    this.state = {
      today: today,
      adt: arrivalDate,
      ddt: departureDate,
      aMinTime: minTime,
      dMinTime: minTime,
      maxTime: maxTime,
      minDate: today,
      absoluteMinDateTime: arrivalDate,
    }
  }

  componentDidMount() {
    window.addEventListener("resize", (event) => {
      this.setState({ screenWidth: event.target.screen.width })
    })

    const newState = {}

    const dtLocale = dateHelper.luxonLocale(this.props.locale)
    const zone = "Europe/Copenhagen"
    const currentTime = DateTime.local().setLocale(dtLocale).setZone(zone)
    const cphTime = currentTime.setZone("local", { keepLocalTime: true })

    if (this.state.adt) {
      const isToday = this.state.today.startOf("day").toMillis() === this.state.adt.startOf("day").toMillis()
      const mintime = cphTime.plus({ hours: this.props.leadTimeInHours || 1 })
      if (isToday) {
        newState["aMinTime"] = mintime
      }
    }

    if (this.state.ddt) {
      const isToday = this.state.today.startOf("day").toMillis() === this.state.ddt.startOf("day").toMillis()
      const mintime = cphTime.plus({ hours: (this.props.leadTimeInHours || 1) + 2 })
      if (isToday) {
        newState["dMinTime"] = mintime
        newState["minDate"] = mintime
      }
    }

    this.setState({ ...newState })
  }

  addEventListeners = () => {
    let dateselect
    if (isMobile) {
      dateselect = document.querySelector("#root-portal")
    } else {
      dateselect = document.querySelector(".dateselect-from")
    }
    setTimeout(() => {
      if (dateselect) {
        const timeItems = dateselect.querySelectorAll(".react-datepicker__time-list-item")
        if (timeItems.length > 0) {
          timeItems.forEach((item) => {
            item.addEventListener("click", () => this.openDdtCalender())
          })
        }
      }
    }, 100)
  }

  handleInput = (event) => {
    const name = event.target.name
    const value = event.target.value
    this.setState({
      [name]: value,
    })
  }

  handleFromDateChange = (dateInput) => {
    const dtLocale = dateHelper.luxonLocale(this.props.locale)
    const zone = "Europe/Copenhagen"
    const currentTime = DateTime.local().setLocale(dtLocale).setZone(zone)
    const cphTime = currentTime.setZone("local", { keepLocalTime: true })

    const newFromDate = DateTime.fromJSDate(dateInput)
    const isToday = this.state.today.startOf("day").toMillis() === newFromDate.startOf("day").toMillis()

    if (isToday) {
      const roundedTime = dateHelper.RoundToNearestMinutesLuxon(cphTime.set({ seconds: 0 }), 30)
      const aMinTime = roundedTime.plus({ hours: this.props.leadTimeInHours || 1 })
      const minDate = newFromDate.plus({ hours: 2 })
      if (newFromDate >= aMinTime) {
        this.setState({ adt: newFromDate, aMinTime: aMinTime, minDate: minDate })
      } else {
        this.setState({ adt: aMinTime, aMinTime: aMinTime, minDate: minDate })
      }
    } else {
      const aMinTime = newFromDate.set({ hours: 0, minutes: 30 })
      this.setState({ adt: newFromDate, aMinTime: aMinTime, minDate: newFromDate })
    }
    const dMinTime = newFromDate.plus({ hours: 2 })
    this.setState({ dMinTime: dMinTime, ddt: null })
    this.addEventListeners()
  }

  handleToDateChange = (dateInput) => {
    const newToDate = DateTime.fromJSDate(dateInput)
    const isToday = this.state.today.startOf("day").toMillis() === newToDate.startOf("day").toMillis()
    const isSameDay = this.state.adt.startOf("day").toMillis() === newToDate.startOf("day").toMillis()

    if (isToday) {
      const dMinTime = this.state.adt.plus({ hours: 2 })
      if (newToDate >= dMinTime) {
        this.setState({ dMinTime: dMinTime, ddt: newToDate })
      } else {
        this.setState({ dMinTime: dMinTime, ddt: dMinTime })
      }
    } else if (isSameDay) {
      const minDateTime = this.state.adt.plus({ hours: 2 })
      if (newToDate > minDateTime) {
        this.setState({ dMinTime: minDateTime, ddt: newToDate })
      } else {
        this.setState({ dMinTime: minDateTime, ddt: minDateTime })
      }
    } else {
      const mintime = newToDate.set({ hours: 0, minutes: 30 })
      if (newToDate.hour === 0 && newToDate.minute === 0 && newToDate.second === 0) {
        this.setState({ ddt: mintime, dMinTime: mintime })
      } else {
        this.setState({ ddt: newToDate, dMinTime: mintime })
      }
    }
  }

  getSearchLink = () => {
    let { adt, ddt } = this.state
    if (!adt || !ddt) return null
    let ad = adt.toFormat("yyyy-MM-dd")
    let at = adt.toFormat("HH:mm")
    let dd = ddt.toFormat("yyyy-MM-dd")
    let dt = ddt.toFormat("HH:mm")

    const searchLink = `${this.props.parkingPageLink}/search?ad=${ad}&at=${at}&dd=${dd}&dt=${dt}`
    return searchLink
  }

  getHighlightDates = (startDate, endDate) => {
    if (!endDate) return [{ "react-datepicker__day--highlighted-start": [startDate.toJSDate()] }]
    const duration = endDate.diff(startDate, ["days"]).toObject()
    const dayDifference = Math.floor(duration.days)

    const highlightDates = [{ "react-datepicker__day--highlighted-start": [startDate.toJSDate()] }]
    const middleDates = []
    for (let i = 1; i < dayDifference + 1; i++) {
      middleDates.push(startDate.plus({ days: i }).toJSDate())
    }
    highlightDates.push({ "react-datepicker__day--highlighted": middleDates })
    highlightDates.push({ "react-datepicker__day--highlighted-end": [endDate.toJSDate()] })
    return highlightDates
  }

  openDdtCalender = () => {
    this.ddtCalender.setOpen(true)
  }

  render() {
    const highlightDates = this.getHighlightDates(this.state.adt, this.state.ddt)
    const imageAlignment = SelectionFactoryHelper.getFromSelectionFactory(this.props.imageAlignment)

    const CustomInput = forwardRef(({ value, onClick, mainLabel }, ref) => (
      <div onClick={onClick} ref={ref}>
        <label>{mainLabel}</label>
        {value.replace(" ", " kl. ")}
      </div>
    ))
    CustomInput.displayName = "CustomInput"

    const FromContainer = ({ className, children }) => {
      return (
        <CustomCalendarContainer className={className} label={this.props.fromLabel || "From"}>
          {children}
        </CustomCalendarContainer>
      )
    }

    const ToContainer = ({ className, children }) => {
      return (
        <CustomCalendarContainer className={className} label={this.props.toLabel || "Til"}>
          {children}
        </CustomCalendarContainer>
      )
    }

    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.buttonColor)
    const searchLink = this.getSearchLink()

    const buttonStyle = { "--btn-hover": this.props.buttonHoverColor }

    return (
      <div>
        <div className={`parking-info-box`} style={buttonStyle}>
          <div className="w--wider">
            {window.innerWidth < 950 || imageAlignment === "left" ? (
              <div className="picture">
                <img loading="eager" fetchPriority="high" src={window.innerWidth < 950 ? this.props.mobileImage : this.props.image}></img>
              </div>
            ) : (
              ""
            )}
            <div className="maincontent">
              <div className="infohead">{this.props.title || "Parkering i lufthavnen"}</div>
              <h2>{this.props.heading || "Spar tid og penge med vores parkeringstilbud fra 395 kroner pr. uge"}</h2>
              <div
                className="maintext"
                dangerouslySetInnerHTML={{
                  __html: this.props.text
                    ? this.props.text
                    : "Book din parkering og få automatisk gratis refunderingsgaranti (værdi 49,-). Find alle muligheder for korttids- eller langtidsparkering, priserlister og praktiske informationer.",
                }}
              ></div>
              {this.props.hideSearchComponent ? (
                <a href={this.props.buttonLink}>
                  <div className={`button button--medium button--general no-shadow ${buttonColor ? buttonColor : ""}`}>
                    <span className="text">{this.props.buttonText || "Book parkering her"}</span>
                  </div>
                </a>
              ) : (
                <div className="dateselect">
                  <div className="form__section form__section--split">
                    <div className={`form__section__inner dateselect-from ${imageAlignment}`}>
                      <DatePicker
                        ref={(r) => (this.adtCalender = r)}
                        selected={this.state.adt.toJSDate()}
                        onChange={(date) => this.handleFromDateChange(date)}
                        showTimeSelect
                        dateFormat={this.props.locale === "en" ? "dd.MM.yyyy h:mm aa" : "dd.MM.yyyy HH:mm"}
                        timeFormat={this.props.locale === "en" ? "h:mm aa" : "HH:mm"}
                        minDate={this.state.today.toJSDate()}
                        minTime={this.state.aMinTime.toJSDate()}
                        maxTime={this.state.maxTime.toJSDate()}
                        locale={this.props.locale === "en" ? enGB : da}
                        customInput={<CustomInput mainLabel={this.props.fromLabel || "Fra"} />}
                        timeCaption={this.props.timeLabel || "Tidspunkt"}
                        highlightDates={highlightDates}
                        onCalendarOpen={this.addEventListeners}
                        withPortal={isMobile ? true : false}
                        portalId={isMobile ? "root-portal" : undefined}
                        calendarContainer={FromContainer}
                        popperPlacement="bottom-start"
                        popperModifiers={[
                          {
                            name: "flip",
                            options: {
                              fallbackPlacements: ["bottom-start"], // disables flip by setting the fallback to the same as the chosen placement
                            },
                          },
                        ]}
                      />
                    </div>
                  </div>
                  <div className="form__section form__section--split">
                    <div className={`form__section__inner dateselect-to ${imageAlignment}`}>
                      <DatePicker
                        ref={(r) => (this.ddtCalender = r)}
                        selected={this.state.ddt ? this.state.ddt.toJSDate() : null}
                        onChange={(date) => this.handleToDateChange(date)}
                        showTimeSelect
                        dateFormat={this.props.locale === "en" ? "dd.MM.yyyy h:mm aa" : "dd.MM.yyyy HH:mm"}
                        timeFormat={this.props.locale === "en" ? "h:mm aa" : "HH:mm"}
                        minDate={this.state.minDate.toJSDate()}
                        minTime={this.state.dMinTime.toJSDate()}
                        maxTime={this.state.maxTime.toJSDate()}
                        locale={this.props.locale === "en" ? enGB : da}
                        customInput={<CustomInput mainLabel={this.props.toLabel || "Til"} />}
                        timeCaption={this.props.timeLabel || "Tidspunkt"}
                        highlightDates={highlightDates}
                        withPortal={isMobile ? true : false}
                        portalId={isMobile ? "root-portal" : undefined}
                        calendarContainer={ToContainer}
                        popperPlacement="bottom-end"
                        popperModifiers={[
                          {
                            name: "flip",
                            options: {
                              fallbackPlacements: ["bottom-end"], // disables flip by setting the fallback to the same as the chosen placement
                            },
                          },
                        ]}
                      />
                    </div>
                  </div>
                  <a href={searchLink}>
                    <div
                      className={`button button--medium button--general no-shadow ${buttonColor ? buttonColor : ""} ${!searchLink ? "disabled" : ""}`}
                    >
                      <span className="text">{this.props.searchButtonLabel || "Søg"}</span>
                    </div>
                  </a>
                </div>
              )}
            </div>
            {imageAlignment === "right" && window.innerWidth >= 950 ? (
              <div className="picture">
                <img loading="eager" fetchPriority="high" src={window.innerWidth < 950 ? this.props.mobileImage : this.props.image}></img>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    )
  }
}

class CustomCalendarContainer extends Component {
  render() {
    return (
      <CalendarContainer className={this.props.className}>
        <div className="react-datepicker__triangle"></div>
        <div className={"calendar-header"}>{this.props.label}</div>
        <div className="calendar-container" style={{ position: "relative", height: "100%" }}>
          {this.props.children}
        </div>
      </CalendarContainer>
    )
  }
}
